"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _RadioGroup.default;
  }
});
Object.defineProperty(exports, "useRadioGroup", {
  enumerable: true,
  get: function get() {
    return _useRadioGroup.default;
  }
});

var _RadioGroup = _interopRequireDefault(require("./RadioGroup"));

var _useRadioGroup = _interopRequireDefault(require("./useRadioGroup"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/RadioGroup/index.js
// module id = 782
// module chunks = 0